export function focusElement(element: HTMLElement, select: boolean = false) {
    if (!element) return false;
    if ("disabled" in element && element.disabled) return false;
    if (select && element instanceof HTMLInputElement) {
        element.select();
        return true;
    } else {
        element.focus();
        return true;
    }
}

function getElementIndexList(element: HTMLElement, base?: HTMLElement) {
    function _getElementIndexList(element: HTMLElement, base: HTMLElement, ret: Array<number>) {
        function getElementIndexInParent(element: HTMLElement) {
            let parentElement = element.parentElement;
            if (parentElement == null) return -1;
            return Array.from(parentElement.children).indexOf(element);
        }

        if (element == base) return ret;
        let elementIndex = getElementIndexInParent(element);
        if (elementIndex == -1) return ret;
        ret.push(elementIndex);
        return _getElementIndexList(element.parentElement!, base, ret);
    }

    if (!base) base = document.body;
    return _getElementIndexList(element, base, []).reverse();
}

export function compareElementPositionInDOM(e1?: HTMLElement, e2?: HTMLElement, base?: HTMLElement) {
    if (e1 == e2) return 0;
    if (e1 == undefined) return 1;
    if (e2 == undefined) return -1;

    if (!base) DebugLog("Comparing with a document body")

    const e1il = getElementIndexList(e1, base);
    const e2il = getElementIndexList(e2, base);

    for (let i = 0; i < Math.max(e1il.length, e2il.length); i++) {
        const e1i = e1il[i];
        const e2i = e2il[i];

        if (e1i === undefined) return -1;
        else if (e2i === undefined) return 1;
        else if (e1i < e2i) return -1;
        else if (e1i > e2i) return 1;
    }

    return 0;
}


//FUNCION PRESTADO (ROBADO) DE https://github.com/bhowell2/binary-insert-js/blob/master/index.ts
//PORQUE NO TUBE GANAS DE IMPLEMENTAR UN BINARY INSERTION
/**
 * Function that takes in two values and compares them.
 * < 0 - should be returned when a < b
 * = 0 - should be returned when a == b
 * > 0 - should be returned when a > b
 */
export type Comparator<T> = (a: T, b: T) => number

/**
 * Takes in a __SORTED__ array and inserts the provided value into
 * the correct, sorted, position.
 * @param array the sorted array where the provided value needs to be inserted (in order)
 * @param insertValue value to be added to the array
 * @param comparator function that helps determine where to insert the value (
 */
export function binaryInsertion<T>(array: T[], insertValue: T, comparator: Comparator<T>) {
    /*
    * These two conditional statements are not required, but will avoid the
    * while loop below, potentially speeding up the insert by a decent amount.
    * */
    if (array.length === 0 || comparator(array[0], insertValue) >= 0) {
        array.splice(0, 0, insertValue)
        return array;
    } else if (array.length > 0 && comparator(array[array.length - 1], insertValue) <= 0) {
        array.splice(array.length, 0, insertValue);
        return array;
    }
    let left = 0, right = array.length;
    let leftLast = 0, rightLast = right;
    while (left < right) {
        const inPos = Math.floor((right + left) / 2)
        const compared = comparator(array[inPos], insertValue);
        if (compared < 0) {
            left = inPos;
        } else if (compared > 0) {
            right = inPos;
        } else {
            right = inPos;
            left = inPos;
        }
        // nothing has changed, must have found limits. insert between.
        if (leftLast === left && rightLast === right) {
            break;
        }
        leftLast = left;
        rightLast = right;
    }
    // use right, because Math.floor is used
    array.splice(right, 0, insertValue);
    return array
}

export function DebugLog(..._: any[]) {
    //console.log(..._);
}